const vietnameseNumberFormat = new Intl.NumberFormat('vi-VN', {
    maximumFractionDigits: 20,
    useGrouping: true
});
const vietnamesePercentNumberFormat = new Intl.NumberFormat('vi-VN', {
    maximumFractionDigits: 2,
    useGrouping: true
});

export const parseLocalizedNumber = (value) => {
    if (typeof value === 'number') return Number.isFinite(value) ? value : NaN;
    if (typeof value !== 'string') return NaN;

    const normalized = value.trim().replace(/\s/g, '').replace(/%$/, '');
    if (!normalized) return NaN;

    let numberString = normalized;
    if (numberString.includes(',')) {
        numberString = numberString.replace(/\./g, '').replace(',', '.');
    }
    const number = Number(numberString);
    return Number.isFinite(number) ? number : NaN;
};

export const formatVietnameseNumber = (value) => {
    const number = parseLocalizedNumber(value);
    return Number.isFinite(number) ? vietnameseNumberFormat.format(number) : value;
};

export const formatCellValue = (value, formatter = formatVietnameseNumber) => {
    const number = parseLocalizedNumber(value);
    if (Number.isFinite(number) && number === 0) return '-';
    return formatter(value);
};

export const formatVietnamesePercent = (ratio) => {
    const number = parseLocalizedNumber(ratio);
    if (!Number.isFinite(number)) return ratio;
    return `${vietnamesePercentNumberFormat.format(number * 100)}%`;
};
